import * as appActions from '../actions/app.actions';

/**
 * App Ready - all required dependencies has been gathered (config / access token).
 */
export function appReady(state: false, {type}: appActions.Actions): boolean {
    switch (type) {
        case appActions.READY: {
            return true;
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/reducers/app-ready.reducer.ts